// `profiles.dob` / `profiles.place` are NOT NULL in the live schema, so Name
// Analysis rows use these neutral placeholders (mirrors the backend's
// controllers/nameAnalysisController.js) — the real signal is
// `data.profileType === 'name_analysis'`.
export const NAME_ANALYSIS_DOB_PLACEHOLDER = '1900-01-01';
export const NAME_ANALYSIS_PLACE_PLACEHOLDER = 'Not provided yet';
